<script>
    import LPTitleView from "./LPTitleView.svelte";
    import WPNSummary from "../Details/WPNSummary.svelte";
    import WPNLocation from "../Details/WPNLocation.svelte";
    import AssetManagement from "../Details/AssetManagement.svelte";
    import WPNNotes from "../Details/WPNNotes.svelte";
    import PhotoCarousel from "../Details/PhotoCarousel.svelte";
    import WPNPersonnelTable from "../Misc/WPNPersonnelTable.svelte";
    import WPNWorkMaterials from "../Misc/WPNWorkMaterials.svelte";
    import WPNRelatedItems from "../Misc/WPNRelatedItems.svelte";
    import WPNItemAttributes from "../Details/WPNItemAttributes.svelte";
    import ActivityProperties from "../Details/ActivityProperties.svelte";
    // import Feedback from "../Details/Feedback.svelte";
    import dbData from "../../Stores/utilityDBStore.js";
    import AlfxSurveyData from "../Misc/ALFXSurveyData.svelte";
    import AlfxLocationData from "../Misc/ALFXLocationData.svelte";
    // import NHMNoiseSourceData from "../Misc/NHMNoiseSourceData.svelte";
    import { createEventDispatcher } from "svelte";
    import { fetchCurrentAuthToken, formRequestAction } from "../../scripts/awsUtils.js";

    const dispatch = createEventDispatcher();
    export let item;
    let buttonActions = [];

    $: willShowBackButton = item["entity"] != "Utility";
    $: buttonActions = ["find-on-map"];

    async function printDetailItem() {
        try {
            let promise = new Promise(fetchCurrentAuthToken);
            promise.then((authToken) => {
                handlePrinting(authToken);
            });
        } catch (error) {
            alert(
                "An error has occurred, please check internet connection and try again."
            );
            console.log(error);
        }
        return;
    }

    async function handlePrinting(authToken) {
        try {
            const ra = formRequestAction("print", { wpn_id: $dbData.wpn_id, item: printItem }, authToken);
            const resDB = await fetch(ra.url, ra.initData);
            if (resDB.ok) {
                // Need to open PDF in new tab / window or download:
                //    https://stackoverflow.com/questions/2805330/opening-pdf-string-in-new-window-with-javascript
                alert("Success: Your PDF report has been sent via email.");
                downloadToFile("Hello ALFX", "nhm.txt", "txt/plain");
            }
        } catch(error) {
            console.error('Error sending Print request: ', error);
        }
    }
</script>

<LPTitleView
    lpTitle={item.name ?? item.wpn2_type}
    showSearch={false}
    {willShowBackButton}
    actions={buttonActions}
    on:back
    on:close-search-table
    on:find-on-map={() => dispatch("find-on-map", { item: item })}
    on:print={printDetailItem}
/>
<div class="lpd-summary" id="printable">
    <!-- 1. Summary: All entities -->
    <WPNSummary {item} />
    <!-- 2. Address & location: All mappable entities -->
    <WPNLocation {item} />
    <AlfxSurveyData sensor={item} />
    <AlfxLocationData locationItem={item} />
    <!-- {#if ['NoiseSource'].includes(item.entity)}
        <NHMNoiseSourceData noiseSource={item} /> -->
        <!-- <Correlation noiseSource={item} />         -->
        <!-- <Feedback {item} /> -->
    <!-- {/if} -->
    <!-- 3. Images: All entities -->
    <PhotoCarousel {item} />
    <!-- 4. Item-specific attributes -->
    <WPNItemAttributes {item} />
    <!-- 5. Item-specific properties -->
    <ActivityProperties {item} />
    <!-- 6a. Asset management: Fixed asset & Pipe -->
    <AssetManagement {item} />
    <!-- 6b. Personnel -->
    <WPNPersonnelTable {item}  />
    <!-- 7. Work Materials -->
    <WPNWorkMaterials {item} />
    <!-- 8. Notes: All entities -->
    <WPNNotes {item} />
    <!-- 8. Related: All categories -->
    <WPNRelatedItems
        {item}
        entities={['FixedAsset', 'Pipe', 'SoundLocation', 'Sensor']}
        cellButtonTypes={["Info", "Map"]}
        on:item-select
        on:find-on-map
    />
</div>

<style>
    :global(.detail-section) {
        padding: 16px;
        border-bottom: 0.25px solid lightgray;
    }
    :global(.detail-section-title) {
        color: #0a6ebd;
        font-size: 1rem;
        font-weight: 400;
        padding: 0 0 10px 0;
    }
    :global(.sensor-data-title) {
        text-align: center;
        width: 100%;
        color: #0a6ebd;
        font-size: 1rem;
        margin: auto;
        font-weight: 200;
    }
    :global(.sensor-data-unavailable) {
        text-align: center;
    }
    :global(.split-view-title) {
        flex: 1;
    }
    :global(.no-border) {
        border-left: hidden;
        border-bottom: hidden;
    }
    :global(.split-title-buttons) {
        display: flex;
    }
</style>
